import type { MouseEvent } from "react";

/** True when the user Cmd+clicks (macOS) or Ctrl+clicks (Windows/Linux) a row. */
export function isModifiedRowClick(
	event?: MouseEvent<HTMLTableRowElement>,
): boolean {
	return Boolean(event?.metaKey || event?.ctrlKey);
}
